import { PartnerId } from '@hc-claims/utilities';
import { createContext } from 'react';

export type Partner = {
  partnerId: PartnerId;
  partnerToken: string;
};

export const PartnerContext = createContext<Partner | undefined>(undefined);
